
import { httpHelper } from './http.service';
import { ENDPOINT } from './urls.service';

class MailService {

  async list(params: URLSearchParams) {
    return httpHelper.get(`${ENDPOINT}/mail/v1/messages`, params);
  }

  async get(id: string) {
    return httpHelper.get(`${ENDPOINT}/mail/v1/messages/${id}`);
  }
}

export const mailService = new MailService();
export default mailService;
